import { render } from "./activos.vue?vue&type=template&id=dca5fe0c"
import script from "./activos.vue?vue&type=script&lang=js"
export * from "./activos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__